<h2 mat-dialog-title>
  {{ data.sensor.display_name }}
</h2>
<mat-dialog-content>
  @if (data.status; as status) {
    <div class="status-row">
      <span
        class="status-dot"
        [style.background-color]="status.effective_color"
      ></span>
      <span>Status: <strong>{{ getStatusLabel(status.status) }}</strong></span>
    </div>
    @if (status.alarm_level && status.alarm_level !== 'none') {
      <div
        class="status-detail"
        >
        Alarmstatus: {{ getAlarmLevelStatusLabel(status.alarm_level) }}
      </div>
    }
    @if (status.max_severity !== null && status.max_severity !== undefined) {
      <div
        class="status-detail"
        >
        Maximal ausgelöst:
        <strong>{{ formatMaximumSeverity(status.max_severity) }}</strong>
      </div>
    }
    @if (status.last_measurement_at) {
      <div class="muted">
        Letzte Messung:
        {{ status.last_measurement_at | date : "short" }}
      </div>
    }
    @if (status.data_status || status.measurement_status) {
      <div
        class="muted"
        >
        Datenstatus:
        {{ getDataStatusLabel(status.data_status || status.measurement_status) }}
      </div>
    }
    @if ((status.active_alarms || []).length) {
      <div class="kv top">
        Aktive Warnungen und Alarme
      </div>
    }
    @for (alarm of status.active_alarms; track alarm) {
      <div class="alarm-row">
        <div class="alarm-meta">
          <strong>{{ alarm.metric }}</strong>
          <span
            class="alarm-level"
            [class.alarm-level--level-1]="alarm.level === 'level_1'"
            [class.alarm-level--level-2]="alarm.level === 'level_2'"
            [class.alarm-level--level-3]="alarm.level === 'level_3'"
            >
            {{ formatAlarmDescriptor(alarm) }}
          </span>
        </div>
        <div class="alarm-values">
          <span class="alarm-comparison-label">Vergleich:</span>
          <span class="alarm-comparison">{{ formatAlarmComparison(alarm) }}</span>
        </div>
        <div class="alarm-context">
          @if (alarm.observed_at) {
            <span>
              Zeitpunkt: {{ alarm.observed_at | date : "short" }}
            </span>
          }
          @if (alarm.source) {
            <span>Quelle: {{ alarm.source }}</span>
          }
        </div>
      </div>
    }
  } @else {
    <div class="muted">Status nicht verfügbar</div>
  }

  <div class="kv top">Fields</div>
  @if ((data.sensor.available_fields || []).length) {
    @for (f of data.sensor.available_fields; track f) {
      <div
        class="field-row"
        [class.loading]="fieldLoading[f.identifier]"
        >
        <div class="field-name">
          {{ f.field_description | translateField }} ({{ f.field_unit }})
        </div>
        <div class="field-value">
          @if (fieldLoading[f.identifier]) {
            <span class="skeleton skeleton-text" style="width: 120px"></span>
          }
          @if (!fieldLoading[f.identifier] && !fieldError[f.identifier]) {
            @if (latestByField[f.identifier]?.epoch) {
              <span class="at">
                &#64; {{ latestByField[f.identifier]?.epoch | date : "short" }}
              </span>
            }
            @if (!latestByField[f.identifier]?.epoch) {
              <span class="at">—</span>
            }
          }
          @if (fieldError[f.identifier]) {
            <span class="error">—</span>
          }
        </div>
      </div>
    }
  } @else {
    <div class="muted">No fields available</div>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
